import Cookies from 'js-cookie';
// The old home's stylesheet. The page is gone (the home and its translations are static pages
// from landing/), but shared components such as the footer still rely on its rules.
import './src/pages/index.css';
import { buildRegisterUrl } from './src/utils';
/**
 * Implement Gatsby's Browser APIs in this file.  
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

// Count a visit through a partner link for the partner's dashboard (the API
// ignores unknown codes and repeat visits). text/plain keeps the beacon a
// simple request, so no CORS preflight.
function reportPartnerVisit(code) {
  try {
    var isLocal = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
    var url = (isLocal ? 'http://localhost:5500' : 'https://api.hyperping.io') + '/v1/partners/visits';
    var body = JSON.stringify({ code: code, url: window.location.href, referrer: document.referrer || '' });
    if (!(navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' })))) {
      fetch(url, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    }
  } catch (e) {}
}

function setCookies() {
  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(window.location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  // Give the URL parameters variable names
  var utm_source = getParameterByName('utm_source');
  var utm_medium = getParameterByName('utm_medium');
  var utm_campaign = getParameterByName('utm_campaign');

  if(utm_source != "" && !Cookies.get("utm_source")) {
    Cookies.set('utm_source', utm_source, { expires: 365 });
  }
  if(utm_medium != "" && !Cookies.get("utm_medium")) {
    Cookies.set('utm_medium', utm_medium, { expires: 365 });
  }
  if(utm_campaign != "" && !Cookies.get("utm_campaign")) {
    Cookies.set('utm_campaign', utm_campaign, { expires: 365 });
  }
  // First-touch referrer. A referrer on our own domain is not an acquisition
  // source: it happens on a hard reload, a target=_blank link between two of
  // our pages, or a return from a status page hosted on hyperping.com, and
  // storing it used to burn the one first-touch slot with "hyperping.com"
  // (9% of stored referrers, 2026-03 to 2026-09). Skip it so the real source
  // of a later visit still gets recorded.
  var referrer = document.referrer;
  var isOwnReferrer = /^https?:\/\/([\w-]+\.)*hyperping\.com(\/|$)/i.test(referrer);
  if(referrer != "" && !isOwnReferrer && !Cookies.get("referrer")) {
    Cookies.set('referrer', referrer, { expires: 365 });
  }

  // Google Ads click ID — unlike the first-touch UTMs above, last click wins
  // (Google attributes conversions to the most recent click). 90 days = the
  // conversion window of the offline import. Rides the register URL to the
  // app (buildRegisterUrl), which lives on hyperping.io where our .com
  // cookies can't follow.
  var gclid = getParameterByName('gclid');
  if (/^[\w-]{10,255}$/.test(gclid)) {
    Cookies.set('gclid', gclid, { expires: 90 });
  }

  // Partner program link (?via=<code>, see partners.hyperping.com). Last link
  // wins over 90 days, the program's attribution window. Rides the register
  // URL and the OAuth state to the app (buildRegisterUrl, encodeOAuthState),
  // which records the referral at signup. The visit is reported so the
  // partner sees their traffic. Same code in landing/src/lib/attribution.ts.
  // `hp_via` is the cookie the short links (partners.hyperping.com/r/<code>)
  // set from the server, on the whole site. Leave it alone when it already
  // holds this code: Safari keeps a server-set cookie 90 days, but caps one
  // rewritten by script at 7.
  var via = getParameterByName('via').trim().toLowerCase();
  if (/^[a-z0-9](?:[a-z0-9-]{1,30})[a-z0-9]$/.test(via)) {
    if (Cookies.get('hp_via') !== via) {
      var onSite = /(^|\.)hyperping\.com$/.test(window.location.hostname);
      Cookies.set('hp_via', via, onSite ? { expires: 90, domain: 'hyperping.com' } : { expires: 90 });
    }
    reportPartnerVisit(via);
  }

  // Paid-traffic flag. gclid identifies one click and rotates on every new
  // click; this boolean marks the visitor as ads-acquired for the whole
  // attribution window so conversion events can be sliced ads vs organic
  // (tagConversionElements adds it as a Plausible prop). First-touch like
  // the UTMs: set once, 365 days.
  var isPaidVisit = /^[\w-]{10,255}$/.test(gclid) ||
    ['cpc', 'ppc', 'paid'].indexOf(getParameterByName('utm_medium').toLowerCase()) !== -1;
  if (isPaidVisit && !Cookies.get('from_ads')) {
    Cookies.set('from_ads', '1', { expires: 365 });
  }

  // Entry page — first page of the first visit (first-touch, like the UTMs
  // above). Rides the register URL to the app (buildRegisterUrl), which
  // stores it on the user at signup so paying accounts can be traced back to
  // the landing page that opened the funnel. Pathname only, strict shape.
  if (!Cookies.get('entry_page') && /^\/(?!\/)[\w\-\/.]{0,254}$/.test(window.location.pathname)) {
    Cookies.set('entry_page', window.location.pathname, { expires: 365 });
  }
}

// The A/B tests were retired on 2026-09-13 (docs/ab-tests-2026-09-archive.md).
// Their cookies had a 30-day max-age, so browsers can still carry them until
// 2026-10-13: expire every name ever used so the app never receives a stale
// ab= value and the cookie jar comes back clean. Remove this after that date.
var RETIRED_AB_COOKIES = [
  'hp_ab_hero', 'hp_ab_hero2',
  'hp_ab_statuspage', 'hp_ab_statuspage2',
  'hp_ab_pricing', 'hp_ab_pricing2', 'hp_ab_pricing3',
  'hp_ab_blog1', 'hp_ab_docs1', 'hp_ab_sla1',
  'hp_ab_seen',
];
function expireRetiredABCookies() {
  RETIRED_AB_COOKIES.forEach(function (name) {
    if (Cookies.get(name) === undefined) return;
    // Same attributes the cookies were written with (path=/, host-only),
    // otherwise the browser treats the removal as a different cookie.
    Cookies.remove(name, { path: '/' });
  });
}

// Exit page for the Google OAuth flow: /oauth-google is a transit page, so
// by the time encodeOAuthState() runs there, location.pathname no longer says
// which page hosted the clicked CTA. Remember the last non-transit page —
// getExitPage() in src/utils.js falls back to it. Session-scoped on purpose:
// the exit page is a property of the visit that converts, not of the visitor.
function rememberExitPage() {
  var p = window.location.pathname;
  if (p.indexOf('/oauth-google') === 0) return;
  try { sessionStorage.setItem('hp_exit_page', p); } catch (e) {}
}

// Tagged events (plausible-event-name= classes) don't receive init customProperties,
// so conversion events like "Signup attempt" arrive with nothing but the page they
// fired on. Attach the attribution props as plausible-event-<prop>= classes directly
// on the tagged elements — the tagged-events script reads classList at click time,
// so late-added classes are picked up.
function tagConversionElements() {
  var elements = document.querySelectorAll('[class*="plausible-event-name="]');

  // Entry page as a conversion-event prop. Plausible already records the page
  // an event fired on (= the exit page), this adds where the funnel began so
  // "Signup attempt" can be sliced by actual landing page. Pathnames contain
  // no spaces or '=' so they are safe as a tagged-event class value.
  var entryPage = Cookies.get('entry_page');
  if (entryPage && /^\/(?!\/)[\w\-\/.]{0,254}$/.test(entryPage)) {
    var entryPrefix = 'plausible-event-entry_page=';
    elements.forEach(function (el) {
      el.classList.forEach(function (cls) {
        if (cls.indexOf(entryPrefix) === 0) el.classList.remove(cls);
      });
      el.classList.add(entryPrefix + entryPage);
    });
  }

  // Paid-traffic flag (from_ads cookie, set in setCookies) as a conversion-
  // event prop, so every conversion breakdown can be filtered ads vs organic.
  if (Cookies.get('from_ads') === '1') {
    elements.forEach(function (el) {
      el.classList.add('plausible-event-from_ads=1');
    });
  }
}

function scheduleConversionTagging() {
  tagConversionElements();
  // Catch CTAs rendered post-mount (currency resolution, modals, hydration patches)
  setTimeout(tagConversionElements, 1500);
  setTimeout(tagConversionElements, 4000);
}

// Components that mount conversion CTAs AFTER the scheduled passes (scroll-
// triggered sticky bars, expanders) call this to get their late links tagged.
if (typeof window !== 'undefined') {
  window.__hpTagConversionElements = tagConversionElements;
}

// Links to the app that bypass buildRegisterUrl: markdown blog posts and docs
// (a plain [Sign up](https://app.hyperping.io/register) in the .md), the
// footer, older components. The attribution cookies live on hyperping.com and
// cannot follow the visitor to app.hyperping.io, so every such click used to
// register with no source at all. Rewrite them at runtime with the same query
// string buildRegisterUrl produces. /login is included on purpose: the app's
// login page stores the same params, so a visitor who clicks "Log in" and then
// "Sign up" keeps their attribution. Links that already carry a query string
// were built by buildRegisterUrl (or carry a draft/plan param) and are left
// alone; without attribution cookies buildRegisterUrl returns the URL as is,
// so re-running the pass is idempotent.
function decorateAppLinks() {
  var anchors = document.querySelectorAll(
    'a[href^="https://app.hyperping.io/register"], a[href^="https://app.hyperping.io/login"]'
  );
  anchors.forEach(function (a) {
    var href = a.getAttribute('href');
    if (!href || href.indexOf('?') !== -1) return;
    var decorated = buildRegisterUrl(href);
    if (decorated !== href) a.setAttribute('href', decorated);
  });
}

// Same timings as the conversion tagging pass: markdown content and late CTAs
// (sticky bars, expanders, hydration patches) mount after the route update.
function scheduleAppLinkDecoration() {
  decorateAppLinks();
  setTimeout(decorateAppLinks, 1500);
  setTimeout(decorateAppLinks, 4000);
}

// /, /pricing, /status-page, /use-cases/ai, /use-cases/education, /use-cases/agencies, /use-cases/saas, /use-cases/cloud-hosting, /mcp, /compare/datadog-alternative, /compare/betterstack-alternative,
// /compare/cronitor-alternative, /compare/healthchecks-io-alternative, /compare/sentry-crons-alternative, /compare/dead-mans-snitch-alternative,
// /server-monitoring, /on-call, /ssl-monitoring, /logs, /api-monitoring, /powered-by, /is-my-site-down, /dns-monitoring, /alerting, /incident-communication, /uptime-monitoring, /cron-job-monitoring and /synthetic-monitoring, in English and under /fr, /de and /nl, are not Gatsby pages:
// they are static documents exported from landing/ into static/ (see
// AGENTS.md). Gatsby has no page-data for them, so a <Link> prefetch downloads the 591 KB 404
// page instead, and a click waits for that download before falling back to a full load.
// Hand these routes to the browser.
var STATIC_PAGES = [
  '/',
  '/pricing',
  '/status-page',
  '/use-cases/ai',
  '/use-cases/education',
  '/use-cases/agencies',
  '/use-cases/saas',
  '/use-cases/cloud-hosting',
  '/mcp',
  '/compare/datadog-alternative',
  '/compare/betterstack-alternative',
  '/compare/cronitor-alternative',
  '/compare/healthchecks-io-alternative',
  '/compare/sentry-crons-alternative',
  '/compare/dead-mans-snitch-alternative',
  '/server-monitoring',
  '/on-call',
  '/ssl-monitoring',
  '/logs',
  '/api-monitoring',
  '/powered-by',
  '/is-my-site-down',
  '/dns-monitoring',
  '/alerting',
  '/incident-communication',
  '/uptime-monitoring',
  '/cron-job-monitoring',
  '/synthetic-monitoring',
];
function isStaticPage(to) {
  if (typeof to !== 'string' || to.charAt(0) !== '/') return false;
  var pathname = to.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  // /is-down and /is-down/<slug> are exported too, in English only.
  if (/^\/is-down(\/[^/]+)?$/.test(pathname)) return true;
  var route = pathname.replace(/^\/(fr|de|nl)(?=\/|$)/, '') || '/';
  return STATIC_PAGES.indexOf(route) !== -1;
}

function routeStaticPagesThroughBrowser() {
  // Link prefetches through ___loader.enqueue (in view) and .hovering (on hover).
  var loader = window.___loader;
  if (loader && !loader.__hpStaticPages) {
    ['enqueue', 'hovering', 'prefetch'].forEach(function (method) {
      var original = loader[method];
      if (typeof original !== 'function') return;
      loader[method] = function (rawPath) {
        return isStaticPage(rawPath) ? false : original.apply(this, arguments);
      };
    });
    loader.__hpStaticPages = true;
  }
  // Link clicks and navigate() both go through ___navigate.
  var navigate = window.___navigate;
  if (typeof navigate === 'function' && !navigate.__hpStaticPages) {
    var routed = function (to, options) {
      if (!isStaticPage(to)) return navigate.apply(this, arguments);
      if (options && options.replace) window.location.replace(to);
      else window.location.assign(to);
    };
    routed.__hpStaticPages = true;
    window.___navigate = routed;
  }
}

export const onClientEntry = () => {
  routeStaticPagesThroughBrowser();
  setCookies();
  expireRetiredABCookies();
  rememberExitPage();

  // Plausible v2 snippet: the tracker script (loaded in src/components/seo.js)
  // drains this queue and starts on init(). Nothing to configure any more —
  // the per-test customProperties left with the A/B tests.
  window.plausible = window.plausible || function() {
    (window.plausible.q = window.plausible.q || []).push(arguments);
  };
  window.plausible.init = window.plausible.init || function (i) {
    window.plausible.o = i || {};
  };
  window.plausible.init();
}

// The development loader and router can be set up after onClientEntry.
export const onInitialClientRender = () => {
  routeStaticPagesThroughBrowser();
}

export const onRouteUpdate = () => {
  scheduleAppLinkDecoration();
  rememberExitPage();
  scheduleConversionTagging();
}
